export const StorageRoomTagType = 'StorageRoom'
export const AllStorageRoomsTag = { type: 'StorageRoom' as const, id: "All" }